import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { ActivityLog } from '@app/core/models/activities-log/activity-log.model';
import { ImportReportModel } from '@app/core/models/administration/imports/import-report.model';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { Observable } from 'rxjs';

import { AdministrationBase } from '../../administration-base';
import { LogsDetailComponent } from '../logs-detail/logs-detail.component';

@Component({
  selector: 'app-activity-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
})
export class ActivityLogsComponent
  extends AdministrationBase<ActivityLog>
  implements OnInit, OnDestroy
{
  exportFileName: string;

  constructor(route: ActivatedRoute, router: Router, dialog: MatDialog, authenticationInfoService: AuthenticationInfoService,) {
    super(dialog, router, route, authenticationInfoService);
    this.title = 'ADMINISTRATION DES LOGS';
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.exportFileName = data.exportFileName;
    });
  }

  protected InnerZoom(model: any): void {
    const modalConfig = new ModalHelper().getActivityDetailConfig(model.Id);
    this.dialog.open(LogsDetailComponent, modalConfig);
  }

  protected activateItem(id: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  protected deactivateItem(id: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  protected importHandler(files: File[]): Observable<ImportReportModel[]> {
    throw new Error('Method not implemented.');
  }
  protected getDataItems(): Observable<ActivityLog[]> {
    throw new Error('Method not implemented.');
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

  onClearFilters = (): void => {
    this.onFiltersCleared.next();
  };

  exportAsExcel(): void {
    this.onExportExcelCaller.next();
  }
}
